/* LSL · Fiches produit façon maquette D (Clarté galactique).
   Complète la mise en page de lsl-pd.css sur les vrais blocs du thème : cartes de versions (étiquette + prix réel),
   galerie (flèches, compteur, vignettes), sommaire de la fiche et barre d'achat collante sur mobile.
   Rien n'est inventé : prix, versions, cadeaux et textes viennent du produit, de Kaching et des sections existantes. */
(() => {
  'use strict';
  const sec = document.querySelector('.shopify-section--main-product');
  if (!sec) return;
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const money = (cents) => (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  const el = (tag, cls, html) => { const e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; };
  const ICON_PREV = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14 5-7 7 7 7"/></svg>';
  const ICON_NEXT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m10 5 7 7-7 7"/></svg>';
  const ICON_SOUND = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12"/></svg>';
  const ICON_PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';

  /* Variantes réelles du produit (prix par version) */
  let product = null;
  const picker0 = sec.querySelector('variant-picker[handle]');
  if (picker0) {
    fetch('/products/' + picker0.getAttribute('handle') + '.js', { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.json() : null)).then((p) => { product = p; schedule(); }).catch(() => {});
  }
  const tagFor = (name) => (/proffie/i.test(name) ? 'Personnalisation' : /neo\s*pixel/i.test(name) ? 'Immersion' : /rgb/i.test(name) ? 'Combat' : '');
  const labelFor = (input) => input && input.id ? sec.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null;
  const nameOf = (label) => { if (!label) return ''; const s = label.querySelector('span:not([class])'); return (s ? s.textContent : label.textContent).trim(); };

  function versions() {
    const fs = sec.querySelector('.product-info .lsl-version-selector');
    if (!fs) return;
    const picker = fs.closest('variant-picker') || sec;
    const chosen = {};
    picker.querySelectorAll('input[type="radio"]:checked[data-option-position]').forEach((i) => { chosen[i.dataset.optionPosition] = nameOf(labelFor(i)); });
    fs.querySelectorAll('input[type="radio"][data-option-position]').forEach((input) => {
      const label = labelFor(input);
      if (!label) return;
      const name = nameOf(label);
      if (!label.querySelector('.lsl-pd-vtag')) {
        const t = tagFor(name);
        if (t) label.prepend(el('span', 'lsl-pd-vtag', t));
      }
      if (product && product.variants) {
        const want = Object.assign({}, chosen, { [input.dataset.optionPosition]: name });
        const v = product.variants.find((x) => [1, 2, 3].every((p) => !want[p] || x['option' + p] === want[p]));
        let ps = label.querySelector('.lsl-pd-vprice');
        if (v) {
          if (!ps) { ps = el('span', 'lsl-pd-vprice'); label.append(ps); }
          const txt = money(v.price);
          if (ps.textContent !== txt) ps.textContent = txt;
        }
      }
    });
    const head = fs.querySelector('.variant-picker__option-info .h-stack');
    if (head && !head.querySelector('.lsl-pd-step')) head.prepend(el('span', 'lsl-pd-step', '1'));
    if (head && !head.querySelector('.lsl-pd-compare') && typeof window.openVersionPopup === 'function') {
      const b = el('button', 'lsl-pd-compare', 'Comparer les versions');
      b.type = 'button';
      b.addEventListener('click', () => window.openVersionPopup());
      head.append(b);
    }
    const help = fs.querySelector('.lsl-version-help-list');
    if (help && document.getElementById('essayer') && !fs.querySelector('.lsl-pd-try')) {
      const a = el('a', 'lsl-pd-try', ICON_SOUND + 'Voir l’allumage et écouter les sons <span aria-hidden="true">↗</span>');
      a.href = '#essayer';
      help.after(a);
    }
  }

  /* Kaching : l'offre garde son propre choix de version, caché sur la fiche. Sans ce réglage, le panier reçoit
     la version chargée au départ même si le client en a choisi une autre. On aligne donc ce choix sur la version
     de la page, une fois par changement de version, et seulement pour les formules à un seul sabre
     (dans les packs à plusieurs sabres, chaque sabre se choisit dans l'offre). */
  function kaching() {
    const vs = sec.querySelector('.product-info variant-picker script[data-variant]');
    let v = null;
    try { v = vs ? JSON.parse(vs.textContent) : null; } catch (e) { v = null; }
    if (!v || !v.id || !Array.isArray(v.options)) return;
    const id = String(v.id);
    sec.querySelectorAll('.product-info kaching-bundles-block .kaching-bundles__bar').forEach((bar) => {
      const slots = bar.querySelectorAll('.kaching-bundles__bar-collection-products .kaching-bundles__collection-product');
      if (slots.length !== 1) return;
      const selects = [...slots[0].querySelectorAll('select')];
      if (!selects.length) return;
      const ok = selects.length === v.options.length && selects.every((s, i) => [...s.options].some((o) => o.value === v.options[i]));
      selects.forEach((s, i) => {
        if (s.dataset.lslSync !== (ok ? 'ok' : 'no')) s.dataset.lslSync = ok ? 'ok' : 'no';
        if (!ok || s.dataset.lslVariant === id) return;
        s.dataset.lslVariant = id;
        if (s.value === v.options[i]) return;
        s.value = v.options[i];
        s.dispatchEvent(new Event('input', { bubbles: true }));
        s.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function offer() {
    const t = sec.querySelector('.product-info .lsl-po .lsl-po__title');
    if (t && !t.querySelector('.lsl-pd-step')) { const s = el('span', 'lsl-pd-step', '2'); s.setAttribute('aria-hidden', 'true'); t.prepend(s, ' '); }
    sec.querySelectorAll('.product-info .kaching-bundles__bars .kaching-bundles__upsell').forEach((u) => {
      const p = u.querySelector('.kaching-bundles__upsell__price');
      const free = !!p && /^0[,.]00\s*€?$/.test(p.textContent.replace(/\s/g, ' ').trim());
      u.classList.toggle('lsl-pd-free', free);
    });
  }

  function cta() {
    const pi = sec.querySelector('safe-sticky.product-info');
    const qty = pi && pi.querySelector('[data-block-type="quantity-selector"]');
    if (pi && qty && !pi.querySelector(':scope > .lsl-pd-steplabel')) {
      pi.append(el('p', 'lsl-pd-steplabel', '<span class="lsl-pd-step">3</span>Quantité et panier'));
    }
  }

  /* Galerie : une photo à la fois, flèches, compteur, vignettes */
  let galBound = null;
  function gallery() {
    const g = sec.querySelector('product-gallery');
    const list = g && g.querySelector('.product-gallery__media-list');
    const wrap = g && g.querySelector('.product-gallery__ar-wrapper');
    if (!list || !wrap) return;
    const items = [...list.querySelectorAll(':scope > .product-gallery__media')].filter((m) => !m.hidden && m.offsetParent !== null);
    const n = items.length;
    const index = () => Math.max(0, Math.min(n - 1, Math.round(list.scrollLeft / Math.max(1, list.clientWidth))));
    const go = (i) => { list.scrollTo({ left: ((i + n) % n) * list.clientWidth, behavior: reduce() ? 'auto' : 'smooth' }); };
    let count = wrap.querySelector('.lsl-pd-count');
    if (n > 1 && !wrap.querySelector('.lsl-pd-arrow')) {
      const prev = el('button', 'lsl-pd-arrow lsl-pd-arrow--prev', ICON_PREV);
      const next = el('button', 'lsl-pd-arrow lsl-pd-arrow--next', ICON_NEXT);
      prev.type = next.type = 'button';
      prev.setAttribute('aria-label', 'Photo précédente');
      next.setAttribute('aria-label', 'Photo suivante');
      prev.addEventListener('click', () => go(index() - 1));
      next.addEventListener('click', () => go(index() + 1));
      wrap.append(prev, next);
    }
    if (n > 1 && !count) { count = el('span', 'lsl-pd-count'); count.setAttribute('aria-live', 'polite'); wrap.append(count); }
    let thumbs = g.querySelector('.lsl-pd-thumbs');
    const sig = items.map((m) => m.dataset.mediaId).join(',');
    if (n > 1 && (!thumbs || thumbs.dataset.sig !== sig)) {
      if (!thumbs) { thumbs = el('div', 'lsl-pd-thumbs'); thumbs.setAttribute('aria-label', 'Photos et vidéos du produit'); wrap.after(thumbs); }
      thumbs.dataset.sig = sig;
      thumbs.innerHTML = '';
      items.forEach((m, i) => {
        const img = m.querySelector('img');
        const b = el('button', 'lsl-pd-thumb');
        b.type = 'button';
        const video = m.dataset.mediaType === 'video' || m.dataset.mediaType === 'external_video';
        b.setAttribute('aria-label', video ? 'Vidéo du produit' : 'Photo ' + (i + 1));
        if (img) { const t = el('img'); t.src = img.currentSrc || img.src; t.alt = ''; t.loading = 'lazy'; t.width = 64; t.height = 64; b.append(t); }
        if (video) b.append(el('span', 'lsl-pd-thumb__play', ICON_PLAY));
        b.addEventListener('click', () => go(i));
        thumbs.append(b);
      });
    }
    const paint = () => {
      const i = index();
      const txt = (i + 1) + ' / ' + n;
      if (count && count.textContent !== txt) count.textContent = txt;
      if (thumbs) [...thumbs.children].forEach((b, k) => { const v = String(k === i); if (b.getAttribute('aria-current') !== v) b.setAttribute('aria-current', v); });
    };
    if (galBound !== list) {
      galBound = list;
      let raf = 0;
      list.addEventListener('scroll', () => { clearTimeout(raf); raf = setTimeout(paint, 30); }, { passive: true });
      window.addEventListener('resize', paint);
    }
    paint();
    /* Dimensions sous la galerie, comme sur la maquette */
    const dims = sec.querySelector('.product-info .lsl-dimensions');
    if (dims) { g.querySelectorAll(':scope > .lsl-dimensions').forEach((d) => d.remove()); (thumbs || wrap).after(dims); }
  }

  /* Sommaire de la fiche */
  const PARTS = [
    ['acheter', 'Acheter', '.shopify-section--main-product'],
    ['essayer', 'Essayer et comparer', '.lsl-rgbneo-full, .lsl-rgbneo'],
    ['avis', 'Avis', '.lsl-reviews'],
    ['videos', 'Vidéos', '.lsl-client-videos, .lsl-unboxings'],
    ['coffret', 'Le coffret', '.lsl-box'],
    ['six', '6 choses à savoir', '#lsl-real3d, .lsl-real3d-full'],
    ['questions', 'Questions', '.lsl-native-faq']
  ];
  function toc() {
    if (document.querySelector('.lsl-pd-toc')) return;
    const found = [];
    PARTS.forEach(([id, label, sel]) => {
      const t = document.querySelector(sel);
      const s = t && (t.closest('.shopify-section') || t);
      if (!s || document.getElementById(id) || found.some((f) => f.s === s)) return;
      const a = el('span', 'lsl-pd-anchor');
      a.id = id;
      s.prepend(a);
      found.push({ id, label, s });
    });
    if (found.length < 3) return;
    const nav = el('nav', 'lsl-pd-toc');
    nav.setAttribute('aria-label', 'Sommaire de la fiche');
    const ol = el('ol');
    found.forEach((f, i) => {
      const li = el('li');
      const a = el('a', null, '<i>' + String(i + 1).padStart(2, '0') + '</i>' + f.label);
      a.href = '#' + f.id;
      li.append(a);
      ol.append(li);
    });
    nav.append(ol);
    sec.before(nav);
    if ('IntersectionObserver' in window) {
      const links = new Map(found.map((f) => [f.s, nav.querySelector('a[href="#' + f.id + '"]')]));
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { links.forEach((a) => a.removeAttribute('aria-current')); const a = links.get(e.target); if (a) { a.setAttribute('aria-current', 'true'); a.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } } });
      }, { rootMargin: '-45% 0px -50% 0px' });
      found.forEach((f) => io.observe(f.s));
    }
  }

  /* Barre d'achat collante sur mobile */
  let bar = null, watched = null, io = null;
  function sticky() {
    const btn = sec.querySelector('.product-info .buy-buttons button[type="submit"]');
    if (!btn) return;
    if (!bar) {
      bar = el('div', 'lsl-pd-sticky', '<div class="lsl-pd-sticky__info"><small></small><b></b></div><button type="button">Ajouter au panier</button>');
      document.body.append(bar);
      bar.querySelector('button').addEventListener('click', () => { const b = sec.querySelector('.product-info .buy-buttons button[type="submit"]'); if (b) b.click(); });
      io = new IntersectionObserver(([e]) => { bar.classList.toggle('is-shown', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }
    if (btn !== watched) { if (watched) io.unobserve(watched); io.observe(btn); watched = btn; }
    const chosen = sec.querySelector('.product-info .lsl-version-selector input:checked');
    const name = nameOf(labelFor(chosen)) || (sec.querySelector('.product-info__title') || {}).textContent || '';
    const sale = sec.querySelector('.product-info__price sale-price');
    const price = sale ? [...sale.childNodes].filter((n) => !(n.nodeType === 1 && n.classList.contains('sr-only'))).map((n) => n.textContent).join('').trim() : '';
    const small = bar.querySelector('small'), b = bar.querySelector('b'), action = bar.querySelector('button');
    if (small.textContent !== name.trim()) small.textContent = name.trim();
    if (b.textContent !== price) b.textContent = price;
    action.disabled = btn.disabled;
  }

  let queued = 0;
  function apply() {
    queued = 0;
    try { kaching(); } catch (e) {}
    try { versions(); } catch (e) {}
    try { offer(); } catch (e) {}
    try { cta(); } catch (e) {}
    try { gallery(); } catch (e) {}
    try { toc(); } catch (e) {}
    try { sticky(); } catch (e) {}
  }
  /* setTimeout plutôt que requestAnimationFrame : ce dernier ne part pas tant que l'onglet est en arrière-plan */
  function schedule() { if (!queued) queued = setTimeout(apply, 40); }
  new MutationObserver(schedule).observe(sec, { childList: true, subtree: true, characterData: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  window.addEventListener('load', schedule);
  document.addEventListener('variant:change', schedule);
})();
